import Bookmark from "@untitled-ui/icons-react/build/esm/Bookmark";
import FilterLines from "@untitled-ui/icons-react/build/esm/FilterLines";
import classnames from "classnames";
import { useCallback } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import { showFilterModal } from "../../../../store/reducer/_uiReducer";
import {
  getAppliedFilters,
  getCurrentModelTypeAppliedFilters,
  getCurrentSearchPeriod,
  getSearchModelType,
  getSearchType,
  getSelectedPersonFilter,
} from "../../../../store/selectors";
import { PDLButton } from "../../../components/dna";
import { Logo, OmniBar, UserDetails } from "../../global";
import "./index.scss";

function Header({ headerClass = null }) {
  const dispatch = useDispatch();

  const searchType = useSelector(getSearchType);
  const appliedFilters = useSelector(getAppliedFilters);
  const currentPeriod = useSelector(getCurrentSearchPeriod);
  const selectedPersonFilter = useSelector(getSelectedPersonFilter);
  const appliedModelType = useSelector(getSearchModelType);
  const modalTypeAppliedFilters = useSelector(
    getCurrentModelTypeAppliedFilters
  );

  const currentSearchType = searchType.id;
  const currentAppliedFilterValues =
    appliedFilters[currentSearchType]?.flatMap((filter) => filter.values) ?? [];

  const modalTypeFilterCount =
    currentSearchType !== "modelos" || appliedModelType === "all"
      ? 0
      : modalTypeAppliedFilters.length + 1;

  const filterCount =
    currentAppliedFilterValues.length +
    (currentPeriod?.period && currentPeriod?.period !== "always" ? 1 : 0) +
    (selectedPersonFilter?.length > 2 ? 1 : 0) +
    modalTypeFilterCount;

  const toggleFilterModal = useCallback(() => {
    dispatch(showFilterModal());
  }, [dispatch]);

  return (
    <header className={classnames("pdl_component_header", headerClass)}>
      <Container>
        <Row className="d-none d-md-flex">
          <Col className="d-flex flex-row align-items-center justify-contents-between px-0 py-3">
            <Logo variant={headerClass === "home" ? "header_home" : "header"} />
            <OmniBar headerClass={headerClass} />
            <UserDetails />
          </Col>
        </Row>

        <div className="d-md-none header-mobile">
          <Row className="align-items-center justify-content-between py-2">
            <Col xs="auto" className="ps-0">
              <Logo
                variant={headerClass === "home" ? "header_home" : "header"}
              />
            </Col>
            <Col xs="auto" className="pe-0">
              <UserDetails />
            </Col>
          </Row>

          <Row className="align-items-center py-2">
            <Col xs={9} className="ps-0">
              <OmniBar headerClass={headerClass} isMobile={true} />
            </Col>
            <Col
              xs={3}
              className="pe-0 d-flex justify-content-end header-mobile-buttons"
            >
              {headerClass !== "home" && (
                <>
                  <PDLButton
                    variant="primary"
                    size="sm"
                    className="px-2"
                    disabled={searchType.id === "all"}
                    onClick={toggleFilterModal}
                  >
                    <FilterLines size={16} />
                    {filterCount > 0 && (
                      <p className="count-box">{filterCount}</p>
                    )}
                  </PDLButton>
                  <PDLButton
                    variant="secondary"
                    size="sm"
                    className="px-2"
                    onClick={() => {
                      console.log("Salvar pesquisa");
                    }}
                  >
                    <Bookmark size={16} />
                  </PDLButton>
                </>
              )}
            </Col>
          </Row>
        </div>
      </Container>
    </header>
  );
}
export default Header;
